import { WorkflowTrigger, WorkflowTriggerName } from '@frontend/workflow/types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export enum PackageTriggerName {
    PACKAGE_PROCESS = 'package_process',
    PACKAGE_CANCEL = 'package_cancel',
    PACKAGE_CONTINUE = 'package_continue',
    PACKAGE_STATE_CHANGED = 'package_state_changed',
    PACKAGE_PIN_CODE_CREATED = 'package_pin_code_created',
    PACKAGE_CODE_SCANNED = 'package_code_scanned',
    PACKAGE_SLOT_OPENED = 'package_slot_opened',
    PACKAGE_SLOT_NOT_OPENED = 'package_slot_not_opened',
    PACKAGE_SLOT_CLOSED = 'package_slot_closed',
    PACKAGE_SLOT_NOT_CLOSED = 'package_slot_not_closed',
    PACKAGE_SLOT_ERROR = 'package_slot_error',
    PACKAGE_SLOT_UNLOCKED = 'package_slot_unlocked',
    PACKAGE_SLOT_CANCELLED = 'package_slot_cancelled',
    PACKAGE_ACTUATOR_ERROR = 'package_actuator_error',
    PACKAGE_DROPPED_OFF = 'package_dropped_off',
    PACKAGE_PICKED_UP = 'package_picked_up',
    PACKAGE_PIN_CODE_ENTERED = 'package_pin_code_entered',
    PACKAGE_OPEN_SLOT = 'package_open_slot',
    PACKAGE_MOVE_SLOT = 'package_move_slot',
    PACKAGE_MOVE_SPOT = 'package_move_spot',
    PACKAGE_SLOT_MOVED = 'package_slot_moved',
    PACKAGE_SPOT_MOVED = 'package_spot_moved',
    PACKAGE_REVIEWED_APPROVE_PUT_IN_STOCK = 'package_reviewed_approve_put_in_stock',
    PACKAGE_REVIEWED_APPROVE_REMOVE_FROM_STOCK = 'package_reviewed_approve_remove_from_stock',
    PACKAGE_REVIEWED_DECLINE_WRONG_PRODUCT = 'package_reviewed_decline_wrong_product',
    PACKAGE_REVIEWED_DECLINE_DAMAGED_PRODUCT = 'package_reviewed_decline_damaged_product',
    PACKAGE_REVIEWED_DECLINE_EMPTY_SLOT = 'package_reviewed_decline_empty_slot',
    PACKAGE_SKIP = 'package_skip',
    PACKAGE_AUDITED = 'package_audited'
}
export class PackageTrigger extends WorkflowTrigger {
    static readonly PACKAGE_PROCESS = new PackageTrigger(
        PackageTriggerName.PACKAGE_PROCESS,
        (
            <FormattedMessage
                id='packageTrigger.process'
                description='package trigger process'
                defaultMessage='Package process'
            />
        )
    );

    static readonly PACKAGE_CONTINUE = new PackageTrigger(
        PackageTriggerName.PACKAGE_CONTINUE,
        (
            <FormattedMessage
                id='packageTrigger.continue'
                description='package trigger continue'
                defaultMessage='Continue'
            />
        )
    );

    static readonly PACKAGE_STATE_CHANGED = new PackageTrigger(
        PackageTriggerName.PACKAGE_STATE_CHANGED,
        (
            <FormattedMessage
                id='packageTrigger.state_changed'
                description='package trigger state changed'
                defaultMessage='Package state changed'
            />
        )
    );

    static readonly PACKAGE_PIN_CODE_CREATED = new PackageTrigger(
        PackageTriggerName.PACKAGE_PIN_CODE_CREATED,
        (
            <FormattedMessage
                id='packageTrigger.pin_code_created'
                description='package trigger PIN-code created'
                defaultMessage='PIN-code created'
            />
        )
    );

    static readonly PACKAGE_CODE_SCANNED = new PackageTrigger(
        PackageTriggerName.PACKAGE_CODE_SCANNED,
        (
            <FormattedMessage
                id='packageTrigger.code_scanned'
                description='package trigger code scanned'
                defaultMessage='Code scanned'
            />
        )
    );

    static readonly PACKAGE_SLOT_OPENED = new PackageTrigger(
        PackageTriggerName.PACKAGE_SLOT_OPENED,
        (
            <FormattedMessage
                id='packageTrigger.slot_opened'
                description='package trigger slot opened'
                defaultMessage='SLOT opened'
            />
        )
    );

    static readonly PACKAGE_SLOT_CLOSED = new PackageTrigger(
        PackageTriggerName.PACKAGE_SLOT_CLOSED,
        (
            <FormattedMessage
                id='packageTrigger.slot_closed'
                description='package trigger slot closed'
                defaultMessage='SLOT closed'
            />
        )
    );

    static readonly PACKAGE_CANCEL = new PackageTrigger(
        PackageTriggerName.PACKAGE_CANCEL,
        (
            <FormattedMessage
                id='packageTrigger.cancel'
                description='package trigger cancel'
                defaultMessage='Package cancel'
            />
        )
    );

    static readonly PACKAGE_SLOT_NOT_OPENED = new PackageTrigger(
        PackageTriggerName.PACKAGE_SLOT_NOT_OPENED,
        (
            <FormattedMessage
                id='packageTrigger.slot_not_opened'
                description='package trigger slot not opened'
                defaultMessage='SLOT not opened'
            />
        )
    );

    static readonly PACKAGE_SLOT_NOT_CLOSED = new PackageTrigger(
        PackageTriggerName.PACKAGE_SLOT_NOT_CLOSED,
        (
            <FormattedMessage
                id='packageTrigger.slot_not_closed'
                description='package trigger slot not closed'
                defaultMessage='SLOT not closed'
            />
        )
    );

    static readonly PACKAGE_SLOT_ERROR = new PackageTrigger(
        PackageTriggerName.PACKAGE_SLOT_ERROR,
        (
            <FormattedMessage
                id='packageTrigger.slot_error'
                description='package trigger slot error'
                defaultMessage='SLOT error'
            />
        )
    );

    static readonly PACKAGE_SLOT_UNLOCKED = new PackageTrigger(
        PackageTriggerName.PACKAGE_SLOT_UNLOCKED,
        (
            <FormattedMessage
                id='packageTrigger.slot_unlocked'
                description='package trigger slot unlocked'
                defaultMessage='SLOT unlocked'
            />
        )
    );

    static readonly PACKAGE_SLOT_CANCELLED = new PackageTrigger(
        PackageTriggerName.PACKAGE_SLOT_CANCELLED,
        (
            <FormattedMessage
                id='packageTrigger.slot_cancelled'
                description='package trigger slot cancelled'
                defaultMessage='SLOT cancelled'
            />
        )
    );

    static readonly PACKAGE_ACTUATOR_ERROR = new PackageTrigger(
        PackageTriggerName.PACKAGE_ACTUATOR_ERROR,
        (
            <FormattedMessage
                id='packageTrigger.actuator_error'
                description='package trigger actuator error'
                defaultMessage='Actuator error'
            />
        )
    );

    static readonly PACKAGE_DROPPED_OFF = new PackageTrigger(
        PackageTriggerName.PACKAGE_DROPPED_OFF,
        (
            <FormattedMessage
                id='packageTrigger.dropped_off'
                description='package trigger dropped off'
                defaultMessage='Package dropped off'
            />
        )
    );

    static readonly PACKAGE_PICKED_UP = new PackageTrigger(
        PackageTriggerName.PACKAGE_PICKED_UP,
        (
            <FormattedMessage
                id='packageTrigger.picked_up'
                description='package trigger picked up'
                defaultMessage='Package picked up'
            />
        )
    );

    static readonly PACKAGE_PIN_CODE_ENTERED = new PackageTrigger(
        PackageTriggerName.PACKAGE_PIN_CODE_ENTERED,
        (
            <FormattedMessage
                id='packageTrigger.pin_code_entered'
                description='package trigger PIN-code entered'
                defaultMessage='PIN-code entered'
            />
        )
    );

    static readonly PACKAGE_OPEN_SLOT = new PackageTrigger(
        PackageTriggerName.PACKAGE_OPEN_SLOT,
        (
            <FormattedMessage
                id='packageTrigger.open_slot'
                description='package trigger open slot'
                defaultMessage='Open SLOT'
            />
        )
    );

    static readonly PACKAGE_MOVE_SLOT = new PackageTrigger(
        PackageTriggerName.PACKAGE_MOVE_SLOT,
        (
            <FormattedMessage
                id='packageTrigger.move_slot'
                description='package trigger move slot'
                defaultMessage='Move SLOT'
            />
        )
    );

    static readonly PACKAGE_MOVE_SPOT = new PackageTrigger(
        PackageTriggerName.PACKAGE_MOVE_SPOT,
        (
            <FormattedMessage
                id='packageTrigger.move_spot'
                description='package trigger move spot'
                defaultMessage='Move SPOT'
            />
        )
    );

    static readonly PACKAGE_SLOT_MOVED = new PackageTrigger(
        PackageTriggerName.PACKAGE_SLOT_MOVED,
        (
            <FormattedMessage
                id='packageTrigger.slot_moved'
                description='package trigger slot moved'
                defaultMessage='SLOT moved'
            />
        )
    );

    static readonly PACKAGE_SPOT_MOVED = new PackageTrigger(
        PackageTriggerName.PACKAGE_SPOT_MOVED,
        (
            <FormattedMessage
                id='packageTrigger.spot_moved'
                description='package trigger spot moved'
                defaultMessage='SPOT moved'
            />
        )
    );

    static readonly PACKAGE_REVIEWED_APPROVE_PUT_IN_STOCK = new PackageTrigger(
        PackageTriggerName.PACKAGE_REVIEWED_APPROVE_PUT_IN_STOCK,
        (
            <FormattedMessage
                id='packageTrigger.reviewed_approve_put_in_stock'
                description='package trigger reviewed approve put in stock'
                defaultMessage='Reviewed: Approve put in stock'
            />
        )
    );

    static readonly PACKAGE_REVIEWED_APPROVE_REMOVE_FROM_STOCK = new PackageTrigger(
        PackageTriggerName.PACKAGE_REVIEWED_APPROVE_REMOVE_FROM_STOCK,
        (
            <FormattedMessage
                id='packageTrigger.reviewed_approve_remove_from_stock'
                description='package trigger reviewed approve remove from stock'
                defaultMessage='Reviewed: Approve remove from stock'
            />
        )
    );

    static readonly PACKAGE_REVIEWED_DECLINE_WRONG_PRODUCT = new PackageTrigger(
        PackageTriggerName.PACKAGE_REVIEWED_DECLINE_WRONG_PRODUCT,
        (
            <FormattedMessage
                id='packageTrigger.reviewed_decline_wrong_product'
                description='package trigger reviewed decline wrong product'
                defaultMessage='Reviewed: Decline wrong product'
            />
        )
    );

    static readonly PACKAGE_REVIEWED_DECLINE_DAMAGED_PRODUCT = new PackageTrigger(
        PackageTriggerName.PACKAGE_REVIEWED_DECLINE_DAMAGED_PRODUCT,
        (
            <FormattedMessage
                id='packageTrigger.reviewed_decline_damaged_product'
                description='package trigger reviewed decline damaged product'
                defaultMessage='Reviewed: Decline damaged product'
            />
        )
    );

    static readonly PACKAGE_REVIEWED_DECLINE_EMPTY_SLOT = new PackageTrigger(
        PackageTriggerName.PACKAGE_REVIEWED_DECLINE_EMPTY_SLOT,
        (
            <FormattedMessage
                id='packageTrigger.reviewed_decline_empty_slot'
                description='package trigger reviewed decline empty slot'
                defaultMessage='Reviewed: Decline empty slot'
            />
        )
    );

    static readonly PACKAGE_SKIP = new PackageTrigger(
        PackageTriggerName.PACKAGE_SKIP,
        (
            <FormattedMessage
                id='packageTrigger.skip'
                description='package trigger skip'
                defaultMessage='Skip'
            />
        )
    );

    static readonly PACKAGE_AUDITED = new PackageTrigger(
        PackageTriggerName.PACKAGE_AUDITED,
        (
            <FormattedMessage
                id='packageTrigger.audited'
                description='package trigger audited'
                defaultMessage='Audited'
            />
        )
    );

    static override readonly ALL = [
        PackageTrigger.PACKAGE_CONTINUE,
        PackageTrigger.PACKAGE_ACTUATOR_ERROR,
        PackageTrigger.PACKAGE_CANCEL,
        PackageTrigger.PACKAGE_CODE_SCANNED,
        PackageTrigger.PACKAGE_DROPPED_OFF,
        PackageTrigger.PACKAGE_MOVE_SLOT,
        PackageTrigger.PACKAGE_MOVE_SPOT,
        PackageTrigger.PACKAGE_OPEN_SLOT,
        PackageTrigger.PACKAGE_PICKED_UP,
        PackageTrigger.PACKAGE_PIN_CODE_CREATED,
        PackageTrigger.PACKAGE_PIN_CODE_ENTERED,
        PackageTrigger.PACKAGE_PROCESS,
        PackageTrigger.PACKAGE_SLOT_CANCELLED,
        PackageTrigger.PACKAGE_SLOT_CLOSED,
        PackageTrigger.PACKAGE_SLOT_ERROR,
        PackageTrigger.PACKAGE_SLOT_MOVED,
        PackageTrigger.PACKAGE_SLOT_NOT_CLOSED,
        PackageTrigger.PACKAGE_SLOT_NOT_OPENED,
        PackageTrigger.PACKAGE_SLOT_OPENED,
        PackageTrigger.PACKAGE_SLOT_UNLOCKED,
        PackageTrigger.PACKAGE_SPOT_MOVED,
        PackageTrigger.PACKAGE_STATE_CHANGED,
        PackageTrigger.PACKAGE_REVIEWED_APPROVE_PUT_IN_STOCK,
        PackageTrigger.PACKAGE_REVIEWED_APPROVE_REMOVE_FROM_STOCK,
        PackageTrigger.PACKAGE_REVIEWED_DECLINE_WRONG_PRODUCT,
        PackageTrigger.PACKAGE_REVIEWED_DECLINE_DAMAGED_PRODUCT,
        PackageTrigger.PACKAGE_REVIEWED_DECLINE_EMPTY_SLOT,
        PackageTrigger.PACKAGE_SKIP,
        PackageTrigger.PACKAGE_AUDITED,
        ...super.ALL
    ];

    static override getByValue(trigger: PackageTriggerName | WorkflowTriggerName): WorkflowTrigger | undefined {
        return this.ALL.find((a) => a.value == trigger);
    }
}
